import { QueryClient } from '@tanstack/react-query';

// Single shared QueryClient instance for the whole app — every `useQuery`/`useSuspenseQuery` call
// (see hooks/useContracts.ts, useTemplates.ts, etc.) needs a `QueryClientProvider` above it in the
// tree providing this same instance; see index.tsx for where it's mounted.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
